<template>
  <section class="photo new-report__section">
    <div v-if="mode !== 'view' && !hasPhoto()">
      <h2 class="new-report__heading">UPLOAD A PHOTO?</h2>
      <label for="deer-photo" class="screen-reader-text">Upload a photo</label>
      <input
        id="deer-photo"
        name="deer-photo"
        type="file"
        accept=".jpg,.jpeg"
        @change="storePhoto"
      />
    </div>
    <div v-if="hasPhoto()">
      <h2 class="new-report__heading">UPLOADED PHOTO</h2>
      <img :src="src" alt="Deer image" />
    </div>
  </section>
</template>

<script>
import { get } from "lodash";

export default {
  props: {
    mode: String,
  },

  computed: {
    src() {
      const filename = get(this, "$store.state.incidentReport.photos[0].name");
      return `/incidents/${filename}`;
    },
  },

  methods: {
    hasPhoto() {
      return get(this, "$store.state.incidentReport.photos[0].name");
    },
    storePhoto(event) {
      const files = event.target.files;
      if (files && files.length) {
        this.$store.commit("incidentReport/setPhotos", files);
        Array.from(this.$store.state.incidentReport.photos).forEach((p) =>
          console.log(p.name)
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  img {
    width: 100%;
  }
</style>
